import { defineStore } from 'pinia'

const UserStore = defineStore('store', {
    state: () => ({
        user : {
            apps_perm : []
        }
    }),
})

export default UserStore